if (!customElements.get('discovery-popup')) {
    customElements.define('discovery-popup', class extends HTMLElement {
      connectedCallback() {
        this.controller = new AbortController();
        if (document.readyState === 'loading') {
          document.addEventListener('DOMContentLoaded', () => this.initialize(), { once: true, signal: this.controller.signal });
        } else {
          this.initialize();
        }
      }
      initialize() {
        this.dialog = this.querySelector('dialog');
        if (!this.dialog || !this.isConnected) return;
        this.isEditor = this.dataset.editor === 'true' || Boolean(window.Shopify && window.Shopify.designMode);
        const campaign = this.dataset.campaign || '1';
        this.storageKey = 'parfumae:discovery-popup:dismissed' + (campaign === '1' ? '' : ':' + campaign);
        const options = { signal: this.controller.signal };
        this.querySelector('[data-discovery-close]').addEventListener('click', () => this.dialog.close(), options);
        this.querySelector('[data-discovery-dismiss]').addEventListener('click', () => {
          if (!this.isEditor) {
            try { localStorage.setItem(this.storageKey, 'true'); } catch (error) { /* Storage may be unavailable in private browsers. */ }
          }
          this.dialog.close();
        }, options);
        this.dialog.addEventListener('click', (event) => {
          const bounds = this.dialog.getBoundingClientRect();
          if (event.target === this.dialog && (event.clientX < bounds.left || event.clientX > bounds.right || event.clientY < bounds.top || event.clientY > bounds.bottom)) this.dialog.close();
        }, options);
        this.dialog.addEventListener('close', () => this.unlockScroll(), options);
        this.closest('.shopify-section')?.addEventListener('shopify:section:select', () => this.open(), options);
        this.closest('.shopify-section')?.addEventListener('shopify:section:deselect', () => this.dialog.close(), options);
        let dismissed = false;
        try { dismissed = localStorage.getItem(this.storageKey) === 'true'; } catch (error) { /* Keep the popup usable without storage. */ }
        if (!dismissed || this.isEditor) this.open();
      }
      open() {
        if (this.dialog.open) return;
        this.dialog.showModal();
        this.previousOverflow = document.documentElement.style.overflow;
        document.documentElement.style.overflow = 'hidden';
        this.scrollLocked = true;
      }
      unlockScroll() {
        if (!this.scrollLocked) return;
        document.documentElement.style.overflow = this.previousOverflow;
        this.scrollLocked = false;
      }
      disconnectedCallback() {
        this.dialog?.close();
        this.unlockScroll();
        this.controller.abort();
      }
    });
  }
